import { useSelector } from 'react-redux'
import { StepSchema } from '@feedyou-ai/feedbot-schema'

import { RootState } from '../../../reducers'
import { getStepsSelector } from '../../../selectors/dialog'

export function useSteps(dialogId: string) {
  return useSelector<RootState, StepSchema[]>(getStepsSelector(dialogId))
}
